import * as angular from "angular";

export class ConfigurationProfilesRequestsService {

  /* @ngInject */
  constructor(private ConfigurationProfilesAPI, private $configurationProfiles) {
  }

  createOne(profile) {
    const api = this.ConfigurationProfilesAPI.actions.createOne;
    return this.$$call(api, {}, profile, {});
  }

  getOne(id: string) {
    const api = this.ConfigurationProfilesAPI.actions.getOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  updateOne(profile) {
    const api = this.ConfigurationProfilesAPI.actions.updateOne;
    return this.$$call(api, {}, profile, {id: profile.id});
  }

  deleteOne(profileId) {
    const api = this.ConfigurationProfilesAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: profileId});
  }

  assignAccountsToProfile(profileId, accountIds) {
    const api = this.ConfigurationProfilesAPI.actions.assignAccounts;
    return this.$$call(api, {}, {accountIds: accountIds}, {profileId: profileId});
  }

  getDefaultProfile() {
    const api = this.ConfigurationProfilesAPI.actions.getDefaultProfile;
    return this.$$call(api, {isDefault: true}, {}, {});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$configurationProfiles().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('configurationProfilesRequestsService', ConfigurationProfilesRequestsService);
